import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const PrincipaleButton = styled(Button)(({ theme, margin, fontWeight, padding }) => ({
  marginTop: margin ? margin.top : "20px",
  marginBottom: margin ? margin.bottom : "20px",
  marginLeft: margin ? margin.left : 0,
  marginRight: margin ? margin.right : 0,
  backgroundColor: "#fff",
  border: "solid 1px",
  borderRadius: "56px",
  color: "#0078d0",
  cursor: "pointer",
  display: "inline-block",
  fontFamily:
    "system-ui,-apple-system,system-ui,'Segoe UI',Roboto,Ubuntu,'Helvetica Neue',sans-serif",
  fontSize: "18px",
  outline: 0,
  padding: padding || "16px 21px",
  "&:hover": {
    backgroundColor: "#0078d0",
    color: "#fff",
    transform: "scale(1.1)",
  },
}));
